/* =========================================================
   UNISOURCE PROJECT RATINGS v1
   Works with:
   - Our Work / Client Gallery cards
   - Homepage Just Made cards
========================================================= */
(function () {
  "use strict";

  if (window.__UNISOURCE_PROJECT_RATINGS_V1__) return;
  window.__UNISOURCE_PROJECT_RATINGS_V1__ = true;

  var CONFIG = window.UNISOURCE_PROJECT_RATINGS || {};
  var API_BASE = String(
    CONFIG.apiBase ||
    "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/project-reviews"
  ).replace(/\/+$/, "");

  var summaryCache = new Map();

  function clean(value) {
    return String(value == null ? "" : value).trim();
  }

  function projectIdFor(card) {
    return clean(card && card.getAttribute("data-project-id"))
      .replace(/[^a-zA-Z0-9._-]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 160);
  }

  function projectTitleFor(card) {
    return clean(card && card.getAttribute("data-title")) || "Client project";
  }

  function stars(rating) {
    var rounded = Math.round(Number(rating || 0));
    var out = "";
    for (var i = 1; i <= 5; i += 1) out += i <= rounded ? "★" : "☆";
    return out;
  }

  function summaryText(summary) {
    var count = Number(summary && summary.ratingCount || 0);
    var average = Number(summary && summary.averageRating || 0);
    return count
      ? average.toFixed(1) + " · " + count + " rating" + (count === 1 ? "" : "s")
      : "Not rated yet";
  }

  function renderCardSummary(card, summary) {
    var node = card && card.querySelector("[data-project-rating-summary]");
    if (!node) return;
    node.innerHTML =
      '<span aria-hidden="true" style="color:#f59e0b;font-size:14px">' +
      stars(summary && summary.averageRating) +
      '</span><span>' + summaryText(summary) + '</span>';
  }

  async function getSummary(projectId) {
    if (summaryCache.has(projectId)) return summaryCache.get(projectId);

    var response = await fetch(API_BASE + "/" + encodeURIComponent(projectId), {
      method: "GET",
      cache: "no-store",
      headers: { Accept: "application/json" }
    });

    if (!response.ok) throw new Error("Unable to load project rating.");
    var payload = await response.json();
    var summary = payload && payload.data ? payload.data : {
      projectId: projectId,
      averageRating: 0,
      ratingCount: 0,
      ratingTotal: 0,
      updatedAt: ""
    };

    summaryCache.set(projectId, summary);
    return summary;
  }

  function renderAllCardsForProject(projectId, summary) {
    document.querySelectorAll("[data-project-id]").forEach(function (card) {
      if (projectIdFor(card) === projectId) {
        renderCardSummary(card, summary);
      }
    });
  }

  async function loadCard(card) {
    var id = projectIdFor(card);
    if (!id) return;

    try {
      var summary = await getSummary(id);
      /*
       * Homepage Just Made duplicates cards to create the infinite marquee.
       * The cloned card can be created after the first request starts, so update
       * every card carrying the same project ID instead of only the original node.
       */
      renderAllCardsForProject(id, summary);
    } catch (error) {
      console.warn("[Project Ratings] Summary failed", id, error);
    }
  }

  function findOpenCard(button) {
    return button.closest("[data-gallery-card], [data-ua-showcase-card]");
  }

  function activeHostFor(card) {
    var section = card && card.closest(
      "[data-ua-client-gallery], [data-ua-just-made]"
    );
    return section && section.querySelector("[data-project-rating-form-host]");
  }

  function formHtml(card, summary) {
    var title = projectTitleFor(card);
    return (
      '<section class="ua-project-rating" data-project-rating-form>' +
        '<h4 class="ua-project-rating__heading">Rate this project</h4>' +
        '<div class="ua-project-rating__summary" data-project-form-summary>' +
          '<strong>' + stars(summary.averageRating) + '</strong> ' +
          summaryText(summary) +
        '</div>' +
        '<div class="ua-project-rating__stars" aria-label="Choose a project rating">' +
          [1,2,3,4,5].map(function (value) {
            return '<button class="ua-project-rating__star" type="button" data-project-star="' +
              value + '" aria-label="' + value + ' star' + (value === 1 ? "" : "s") + '">★</button>';
          }).join("") +
        '</div>' +
        '<form class="ua-project-rating__grid" novalidate>' +
          '<input type="hidden" name="rating" value="">' +
          '<input type="text" name="companyWebsite" tabindex="-1" autocomplete="off" style="position:absolute;left:-9999px" aria-hidden="true">' +
          '<label>Name <span>(optional)</span><input type="text" name="name" maxlength="160"></label>' +
          '<label>Email <span>(required, never displayed)</span><input type="email" name="email" required maxlength="240"></label>' +
          '<label class="ua-project-rating__full">Comment <span>(optional; reviewed before public display)</span><textarea name="comment" maxlength="1000"></textarea></label>' +
          '<label class="ua-project-rating__consent"><input type="checkbox" name="consent" required><span>I agree that Unisource Apparel may save this rating and use my information to manage my submission.</span></label>' +
          '<button class="ua-project-rating__submit" type="submit">Submit rating</button>' +
          '<div class="ua-project-rating__message" data-project-rating-message aria-live="polite"></div>' +
        '</form>' +
      '</section>'
    );
  }

  function updateStarButtons(root, selected) {
    root.querySelectorAll("[data-project-star]").forEach(function (button) {
      var value = Number(button.getAttribute("data-project-star"));
      button.classList.toggle("is-active", value <= selected);
      button.setAttribute("aria-pressed", value === selected ? "true" : "false");
    });
  }

  async function mountForm(card) {
    var id = projectIdFor(card);
    var host = activeHostFor(card);
    if (!id || !host) return;

    var summary;
    try {
      summary = await getSummary(id);
    } catch (error) {
      summary = { projectId: id, averageRating: 0, ratingCount: 0, ratingTotal: 0 };
    }

    host.innerHTML = formHtml(card, summary);

    var root = host.querySelector("[data-project-rating-form]");
    var form = root.querySelector("form");
    var ratingInput = form.elements.rating;
    var message = root.querySelector("[data-project-rating-message]");

    root.querySelectorAll("[data-project-star]").forEach(function (button) {
      button.addEventListener("click", function () {
        var value = Number(button.getAttribute("data-project-star"));
        ratingInput.value = String(value);
        updateStarButtons(root, value);
      });
    });

    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      message.className = "ua-project-rating__message";
      message.textContent = "";

      var rating = Number(ratingInput.value);
      var email = clean(form.elements.email.value);
      var consent = Boolean(form.elements.consent.checked);

      if (!rating) {
        message.classList.add("is-error");
        message.textContent = "Choose a rating from 1 to 5 stars.";
        return;
      }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        message.classList.add("is-error");
        message.textContent = "Please enter a valid email address.";
        return;
      }
      if (!consent) {
        message.classList.add("is-error");
        message.textContent = "Please check the consent box.";
        return;
      }

      var submit = form.querySelector(".ua-project-rating__submit");
      submit.disabled = true;
      submit.textContent = "Submitting…";

      try {
        var response = await fetch(API_BASE + "/" + encodeURIComponent(id), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            projectTitle: projectTitleFor(card),
            name: clean(form.elements.name.value),
            email: email,
            rating: rating,
            comment: clean(form.elements.comment.value),
            consent: true,
            companyWebsite: clean(form.elements.companyWebsite.value)
          })
        });

        var payload = await response.json().catch(function () { return {}; });
        if (!response.ok || !payload.success) {
          throw new Error(payload.error || "Unable to save your rating.");
        }

        var updated = payload.data && payload.data.summary
          ? payload.data.summary
          : await getSummary(id);

        summaryCache.set(id, updated);
        renderAllCardsForProject(id, updated);

        var formSummary = root.querySelector("[data-project-form-summary]");
        if (formSummary) {
          formSummary.innerHTML =
            "<strong>" + stars(updated.averageRating) + "</strong> " +
            summaryText(updated);
        }

        message.classList.add("is-success");
        message.textContent = payload.message || "Thank you for rating this project.";
      } catch (error) {
        message.classList.add("is-error");
        message.textContent = error && error.message
          ? error.message
          : "Unable to save your rating right now.";
      } finally {
        submit.disabled = false;
        submit.textContent = "Submit rating";
      }
    });
  }

  function initCards(root) {
    root.querySelectorAll("[data-project-id]").forEach(loadCard);
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-gallery-open], [data-ua-open-showcase]");
    if (!button) return;
    var card = findOpenCard(button);
    if (!card) return;
    window.setTimeout(function () { mountForm(card); }, 0);
  }, true);

  function initWithCloneRescan() {
    initCards(document);

    /*
     * The homepage marquee clones its project cards during DOMContentLoaded.
     * Re-scan shortly afterward so any newly cloned cards receive the cached
     * project summaries too.
     */
    window.setTimeout(function () {
      initCards(document);
    }, 150);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWithCloneRescan, { once: true });
  } else {
    initWithCloneRescan();
  }
})();